import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const ActionButton = ({ children, className, show, ...props }) => {
  if (show === false) {
    return null;
  }

  return (
    <button className={classNames("action-button", className)} {...props}>
      {children}
    </button>
  );
};

ActionButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  show: PropTypes.bool
};

export { ActionButton };
